import { FC, useCallback, useState } from "react";
import Image from "next/image";
import { MDBBtn, MDBCol, MDBRow } from "mdb-react-ui-kit";
import styles from "../../styles/detail/DetailHotelCard.module.scss";
import userInterfaceSvg from "../../utils/svg-icon/userInterface";
import socialAndBrandSvg from "../../utils/svg-icon/socialAndBrand";
import { HotelReadableTO } from "../../models/detail";

const PackageDetailHotelCard: FC<{
    packageAccommodation: HotelReadableTO;
    currentIndex: number;
    hotelGalleryHandler: (currentIndex: number) => void;
    isPremium: boolean;
}> = ({
    packageAccommodation,
    currentIndex,
    hotelGalleryHandler,
    isPremium,
}) => {
    const { StarFilled, StarLine } = userInterfaceSvg;
    const { SketchLine } = socialAndBrandSvg;

    const [coverError, setCoverError] = useState(false);

    const getStars = useCallback(() => {
        return Array.from(
            { length: +(packageAccommodation?.stars ?? "0") },
            (value, key) => <StarFilled key={key} />
        );
    }, [packageAccommodation?.stars]);

    return (
        <div
            className={`${styles.container}`}
            onClick={() => hotelGalleryHandler(currentIndex)}
        >
            <div className={styles.cardImageContainer}>
                <Image
                    src={
                        coverError
                            ? "/images/tours/across-italy-reduced.jpg"
                            : packageAccommodation.image
                    }
                    className={styles.imageDescription}
                    alt="card-image"
                    fill
                    onError={() => {
                        setCoverError(true);
                    }}
                />
                <div
                    className={
                        isPremium ? styles.tagPremium : styles.tagQuality
                    }
                >
                    <MDBRow className="me-3 ms-2">
                        <MDBCol
                            size={5}
                            center
                            className="d-inline-flex px-1 justify-content-center"
                        >
                            {isPremium ? <SketchLine /> : <StarLine />}
                        </MDBCol>
                        <MDBCol size={5} center className="d-inline-flex px-1">
                            {isPremium ? "Premium" : "Quality"}
                        </MDBCol>
                    </MDBRow>
                </div>
                <div className={styles.overlay} />
            </div>
            <div className={styles.cardDataContainer}>
                <div className={styles.cardDataContainer2}>
                    <h3 className={styles.cardName}>
                        {packageAccommodation.name}
                    </h3>
                    <div className={styles.starContainer}>{getStars()}</div>
                </div>
                <div className="w-100">
                    <div className={styles.descriptionDivider} />
                    <MDBBtn
                        className={styles.roomsButton}
                        onClick={() => hotelGalleryHandler(currentIndex)}
                    >
                        <span>Check it out</span>
                    </MDBBtn>
                </div>
            </div>
        </div>
    );
};

export default PackageDetailHotelCard;
